// extracted by mini-css-extract-plugin
module.exports = {"filter":"_3xA5Bk1m-SNrGUooY8dH2Z"};